export class FiltroSetor {
  nome?: string
}
